import { useEffect, useState, useRef } from "react";

import styles from "./Face2.module.scss";

export default function Face2() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined
  );
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.028 * cardRef.current.clientWidth));
        setLetterSpacing(0.006 * cardRef.current.clientWidth);
        setLineHeight(0.07 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          letterSpacing: `${letterSpacing}px`,
          lineHeight: `${lineHeight}px`,
        }}
      >
        <p>Kažeš</p>
        <p>Ogoli je, ogoli je!</p>
        <p>i onda kad se caklim</p>
        <p>bježiš u horoskope.</p>
        <p>Ne može,</p>
        <p>to tako ne ide</p>
        <p>Jedan po jedan</p>
        <p>unazad, poredan</p>
        <p>najgori</p>
        <p>baš užasan.</p>
        <p>(i sutra menzis).</p>
      </div>
    </div>
  );
}
